// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k26M","controls":"styles_controls__3RdoE","charLimit":"styles_charLimit__mmc5h","input":"styles_input__2UTGy","send":"styles_send__c0Z53"};